// Development Configuration
// Toggle various development features on/off

export const DEV_CONFIG = {
  // Contact Form Testing
  SHOW_TEST_BUTTON: false,
};

// Helper function to get config values
export const getDevConfig = (key) => {
  return DEV_CONFIG[key];
};

// Helper function to check if feature is enabled
export const isFeatureEnabled = (key) => {
  return DEV_CONFIG[key] === true;
};
